module.exports = __webpack_public_path__ + "img/devpost_icon.a2c6f771.png";